//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

//
// Types
//

export type RequestBody = z.infer<typeof RequestBodySchema>;

export const RequestBodySchema = z.object(
	{
		releaseBranchVersion_id: z.coerce
			.number()
			.int()
			.min(1),

		title: z
			.string()
			.trim()
			.min(1)
			.max(100)
			.default("Download"),

		totalChunkCount: z
			.number()
			.int()
			.min(1),
	});

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema.extend(
			{
				releaseBranchVersionUploadSession_id: z.number(),
			}),

		FritterApiUtilities.ErrorResponseBodySchema,
	]);